export default __webpack_public_path__ + "images/22c05e126ec6b0949cdb1b0e1806758c.jpg";